<template>
  <div>
    <PageHeader
      title="รายงานการขายหลักสูตร"
      style="margin-left: -10%;"
    ></PageHeader>
    <b-container class="widthPage pt-5">
      <h5 class="mb-5">
        <strong>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</strong>
      </h5>
      <!-- ROW Date and Toggle -->
      <b-row>
        <b-col cols="3" class="mb-4">
          <label class="form-label">วันที่ชำระเงิน</label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="timerange"
              size="sm"
              type="text"
              :value="showRange"
              placeholder="วันที่เริ่มสั่งซื้อ - วันที่สิ้นสุดสั่งซื้อ"
              disabled
            />
            <b-input-group-prepend>
              <b-button
                size="sm"
                variant="primary"
                @click="showCalendarRange()"
              >
                <b-icon icon="calendar-range"></b-icon>
              </b-button>
            </b-input-group-prepend>
          </b-input-group>
          <DatePicker
            id="calendar-range-order"
            style="
              display: none;
              float: right;
              position: absolute;
              left: 15px;
              z-index: 999;
            "
          >
            <template #default>
              <div
                style="padding: 10px 0 5px;
                          background: white;
                          width: 674px;
                          border-style: solid solid none solid;
                          border-color: whitesmoke;
                          border-width: 1px;
                        "
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-icon
                      icon="calendar"
                      class="input-group-text icon"
                    ></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    class="inputDate"
                    size="sm"
                    style="margin-right: 1rem;"
                    :value="formatStartDate"
                  >
                  </b-form-input>
                  <b-input-group-prepend>
                    <b-icon
                      icon="calendar"
                      class="input-group-text icon"
                    ></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    class="inputDate"
                    size="sm"
                    style="margin-right: 1rem;"
                    :value="formatEndDate"
                  >
                  </b-form-input>
                  <b-button
                    style="margin-right: 0.5rem;"
                    size="sm"
                    variant="primary"
                    @click="applyCalendarRange()"
                  >
                    Apply
                  </b-button>
                  <b-button
                    style="margin-right: 1rem;"
                    size="sm"
                    variant="light"
                    @click="showCalendarRange()"
                  >
                    Cancel
                  </b-button>
                </b-input-group>
              </div>
              <div
                style="background: white; 
                          padding-left: 10px;
                          padding-bottom: 10px;
                          border-style: none solid solid solid;
                          border-color: whitesmoke;
                          border-width: 1px;
                          position: relative;
                          z-index: 9;"
              >
                <DatePicker
                  v-model="range"
                  @input="onRangeChange"
                  :columns="$screens({ default: 1, sm: 2 })"
                  is-range
                />
              </div>
            </template>
          </DatePicker>
        </b-col>
        <b-col v-if="isWannasorn" cols="3" class="mb-4">
          <label class="form-label">สถาบัน</label>
          <b-form-select
            v-model="selectedSubCompany"
            :options="subCompanyOptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <!-- ROW 2 -->
      <b-row>
        <b-col cols="3" class="mb-4">
          <label class="form-label">หมวดหมู่คอร์ส</label>
          <v-select
            :options="courseTagOptions"
            v-model="selectedCourseTag"
            label="tagName"
            :clearable="false"
          />
        </b-col>
        <b-col cols="3" class="mb-4">
          <label class="form-label">วิชา</label>
          <v-select
            :options="subjectTypeOptions"
            v-model="selectedSubjectType"
            label="label"
            :clearable="false"
          />
        </b-col>
      </b-row>
      <!-- ROW 3 -->
      <b-row>
        <b-col cols="3" class="mb-4">
          <label class="form-label">สถานะคอร์ส</label>
          <v-select
            :options="coursesStatusOptions"
            v-model="selectedCourseStatus"
            label="label"
            :clearable="false"
          />
        </b-col>
        <b-col cols="3" class="mb-4">
          <label class="form-label">ช่องทางการชำระเงิน</label>
          <v-select
            :options="paymentMethodOptions"
            v-model="selectedPaymentMethod"
            label="label"
            :clearable="false"
          />
        </b-col>
      </b-row>
      <!-- ROW 4 -->
      <b-row>
        <b-col cols="3" class="mb-4">
          <label class="form-label">รหัสคอร์ส</label>
          <b-form-input
            class="input-course-code"
            v-model="courseCode"
            placeholder="พิมพ์รหัสคอร์ส"
          />
        </b-col>
        <b-col cols="5" class="mb-4">
          <label class="form-label">ชื่อคอร์ส</label>
          <v-select
            :options="courseListOptions"
            v-model="courseSelected"
            label="label"
            :clearable="false"
          />
        </b-col>
      </b-row>
      <!-- ROW 5 -->
      <b-row>
        <b-col cols="3" class="mb-4">
          <label class="form-label">ประเภทคอร์ส</label>
          <v-select
            :options="courseType"
            v-model="selectedCourseType"
            label="label"
            :clearable="false"
          />
        </b-col>
        <b-col cols="3" class="mb-4">
          <label class="form-label">การขาย</label>
          <v-select
            :options="coursePaidFlag"
            v-model="selectedCoursePaidFlag"
            label="label"
            :clearable="false"
          />
        </b-col>
      </b-row>

      <!-- Everything from สถาบัน downward is only shown when advanced search is on -->
      <template v-if="isAdvancedSearch">
        <!-- ROW 1B -->
        <b-row>
          <b-col v-if="isWannasorn" cols="3" class="mb-4">
            <label class="form-label">สถาบัน</label>
            <b-form-select
              v-model="selectedSubCompany"
              :options="subCompanyOptions"
            ></b-form-select>
          </b-col>
        </b-row>
        <!-- ROW 2 -->
        <b-row>
          <b-col cols="3" class="mb-4">
            <label class="form-label">หมวดหมู่คอร์ส</label>
            <v-select
              :options="courseTagOptions"
              v-model="selectedCourseTag"
              label="tagName"
              :clearable="false"
            />
          </b-col>
          <b-col cols="3" class="mb-4">
            <label class="form-label">ทำรายการโดย</label>
            <v-select
              :options="purchaseByOptions"
              v-model="selectedPurchaseBy"
              label="label"
              :clearable="false"
            />
          </b-col>
          <b-col cols="3" class="mb-4">
            <label class="form-label">สถานะคอร์ส</label>
            <v-select
              :options="coursesStatusOptions"
              v-model="selectedCourseStatus"
              label="label"
              :clearable="false"
            />
          </b-col>
        </b-row>
        <!-- ROW 3 -->
        <b-row>
          <b-col cols="3" class="mb-4">
            <label class="form-label">วิชา</label>
            <v-select
              :options="subjectTypeOptions"
              v-model="selectedSubjectType"
              label="label"
              :clearable="false"
            />
          </b-col>
          <b-col cols="3" class="mb-4">
            <label class="form-label">ช่องทางการชำระเงิน</label>
            <v-select
              :options="paymentMethodOptions"
              v-model="selectedPaymentMethod"
              label="label"
              :clearable="false"
            />
          </b-col>
        </b-row>
        <!-- ROW 4 -->
        <b-row>
          <b-col cols="3" class="mb-4">
            <label class="form-label">รหัสคอร์ส</label>
            <b-form-input
              class="input-course-code"
              v-model="courseCode"
              placeholder="พิมพ์รหัสคอร์ส"
            />
          </b-col>
          <b-col cols="5" class="mb-4">
            <label class="form-label">ชื่อคอร์ส</label>
            <v-select
              :options="courseListOptions"
              v-model="courseSelected"
              label="label"
              :clearable="false"
            />
          </b-col>
        </b-row>
        <!-- ROW 5 -->
        <b-row>
          <b-col cols="3" class="mb-4">
            <label class="form-label">ประเภทคอร์ส</label>
            <v-select
              :options="courseType"
              v-model="selectedCourseType"
              label="label"
              :clearable="false"
            />
          </b-col>
          <b-col cols="3" class="mb-4">
            <label class="form-label">การขาย</label>
            <v-select
              :options="coursePaidFlag"
              v-model="selectedCoursePaidFlag"
              label="label"
              :clearable="false"
            />
          </b-col>
        </b-row>
      </template>

      <b-button
        @click="searchCourseSalesHistory()"
        class="mt-4"
        variant="primary"
      >
        ค้นหาข้อมูล
      </b-button>

      <CourseSalesReportPanel
        :items="courseSalesHistory"
        :paramsValue="courseSalesParamsValue"
        :paramsLabel="courseSalesParamsLabel"
      />
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@/services/api.js";
import vSelect from "vue-select";
import PageHeader from "@/components/layouts/PageHeader.vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import CourseSalesReportPanel from "./panel/CourseSalesReportPanel.vue";
import subCompanyFilterMixin from "../../../../mixins/sub-company-filter-mixin";

export default {
  mixins: [subCompanyFilterMixin],
  components: {
    PageHeader,
    vSelect,
    DatePicker,
    CourseSalesReportPanel,
  },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      isAdvancedSearch: false,
      membersData: [],
      selectedMember: null,
      hasMembersData: true,
      coursesData: [],
      allCourses: [],
      allSubjects: [],
      allTags: [],
      courseSelected: { label: "ทั้งหมด", value: "" },
      selectedCourseTag: { tagName: "ทั้งหมด", tagId: null, comId: null },
      coursePaidFlag: [
        { label: "เฉพาะที่ขายได้แล้ว", value: 1 },
        { label: "เฉพาะที่ยังขายไม่ได้", value: 0 },
      ],
      selectedCoursePaidFlag: { label: "เฉพาะที่ขายได้แล้ว", value: 1 },
      selectedPurchaseBy: { label: "ทั้งหมด", value: "" },
      allPurchaseByOptions: [
        { label: "ทั้งหมด", value: "" },
        { label: "แอดมิน", value: "ADMIN" },
        { label: "นักเรียน", value: "STUDENT" },
      ],
      selectedSubjectType: { label: "ทั้งหมด", value: "" },
      allCourseType: [
        { label: "ทั้งหมด", value: "" },
        { label: "คอร์สออนไลน์", value: "ONLINE" },
        { label: "คอร์สรอบสอนสด", value: "ONSITE" },
      ],
      selectedCourseType: { label: "ทั้งหมด", value: "" },
      allCoursesStatusOptions: [
        { label: "สถานะทั้งหมด", value: "" },
        { label: "กำลังเผยแพร่", value: "PUBLISH" },
        { label: "พักการเผยแพร่", value: "SUSPEND" },
      ],
      selectedCourseStatus: { label: "สถานะทั้งหมด", value: "" },
      allPaymentMethodOptions: [
        { label: "ทั้งหมด", value: [] },
        { label: "KTB", value: ["ONLINEBANKING", "TRANSFER"] },
        { label: "KTC", value: ["CREDITCARD"] },
        { label: "Offline", value: ["CASH"] },
      ],
      selectedPaymentMethod: { label: "ทั้งหมด", value: [] },
      courseCode: null,
      isCardShow: false,
      range: {
        start: moment().subtract(90, "days").toDate(),
        end: moment().toDate(),
      },
      fetchParams: {
        selectedMonth: "",
        startDate: "",
        endDate: "",
        courseName: "",
        paid: "",
      },
      courseList: [],
      subjectList: [],
      courseSalesHistory: null,
      courseSalesSummary: {
        totalSales: 0,
        totalAmount: 0,
      },
      courseSalesParamsValue: {
        startDate: null,
        endDate: null,
        cId: null,
        purchaseBy: null,
        subjectId: null,
        cName: null,
        cCode: null,
        cTagId: null,
        paidFlag: null,
        cStatus: null,
        method: null,
        cType: null,
      },
      courseSalesParamsLabel: {
        startDate: null,
        endDate: null,
        cId: null,
        subjectId: null,
        cName: null,
        cCode: null,
        cTagId: null,
        paidFlag: null,
        cStatus: null,
        method: null,
        cType: null,
      },
    };
  },
  created() {
    this.getSubjectData();
    this.getTags();
    this.getCourses();
    if (this.isWannasorn) {
      this.loadSubCompanyDropdown();
    }
  },
  computed: {
    ...mapGetters("LearningHistory", ["isLoading", "learningHistoryList"]),
    ...mapGetters("CourseManagement", ["courseList"]),
    showRange() {
      if (this.range.start != null && this.range.end != null) {
        return (
          moment(this.range.start).format("DD/MM/YYYY") +
          " - " +
          moment(this.range.end).format("DD/MM/YYYY")
        );
      } else {
        return null;
      }
    },
    formatStartDate() {
      if (this.range.start != null) {
        return moment(this.range.start).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formatEndDate() {
      if (this.range.end != null) {
        return moment(this.range.end).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    paymentMethodOptions() {
      const purchaseBy = this.selectedPurchaseBy
        ? this.selectedPurchaseBy.value
        : "";

      if (purchaseBy === "ADMIN") {
        return this.allPaymentMethodOptions.filter(
          (opt) =>
            opt.value.length === 0 ||
            opt.value.every((v) => ["CASH"].includes(v)),
        );
      }

      if (purchaseBy === "STUDENT") {
        const allowed = ["TRANSFER", "ONLINEBANKING", "CREDITCARD"];
        return this.allPaymentMethodOptions.filter(
          (opt) =>
            opt.value.length === 0 ||
            opt.value.every((v) => allowed.includes(v)),
        );
      }

      return this.allPaymentMethodOptions;
    },
    purchaseByOptions() {
      const methodValues = this.selectedPaymentMethod
        ? this.selectedPaymentMethod.value
        : [];

      if (methodValues.includes("CASH")) {
        return this.allPurchaseByOptions.filter((opt) =>
          ["", "ADMIN"].includes(opt.value),
        );
      }

      if (
        methodValues.some((v) =>
          ["TRANSFER", "ONLINEBANKING", "CREDITCARD"].includes(v),
        )
      ) {
        return this.allPurchaseByOptions.filter((opt) =>
          ["", "STUDENT"].includes(opt.value),
        );
      }

      return this.allPurchaseByOptions;
    },

    coursesFilteredExceptCourse() {
      return this.allCourses.filter((c) => {
        if (this.selectedSubjectType?.value && c.subjectId !== this.selectedSubjectType.value) return false;
        if (this.selectedCourseTag?.tagId) {
          const tagIds = (c.courseTags || []).map((t) => t.tagId);
          if (!tagIds.includes(this.selectedCourseTag.tagId)) return false;
        }
        if (this.selectedCourseStatus?.value && c.courseStatus !== this.selectedCourseStatus.value) return false;
        if (this.selectedCourseType?.value && c.courseOnlineType !== this.selectedCourseType.value && c.courseOnlineType !== "FLEX") return false;
        if (this.courseCode && !(c.courseCode || "").includes(this.courseCode)) return false;
        return true;
      });
    },
    coursesFilteredExceptStatus() {
      return this.allCourses.filter((c) => {
        if (this.selectedSubjectType?.value && c.subjectId !== this.selectedSubjectType.value) return false;
        if (this.selectedCourseTag?.tagId) {
          const tagIds = (c.courseTags || []).map((t) => t.tagId);
          if (!tagIds.includes(this.selectedCourseTag.tagId)) return false;
        }
        if (this.selectedCourseType?.value && c.courseOnlineType !== this.selectedCourseType.value && c.courseOnlineType !== "FLEX") return false;
        if (this.courseCode && !(c.courseCode || "").includes(this.courseCode)) return false;
        if (this.courseSelected?.value && c.courseId !== this.courseSelected.value) return false;
        return true;
      });
    },
    coursesStatusOptions() {
      const validStatuses = new Set(this.coursesFilteredExceptStatus.map((c) => c.courseStatus));
      return this.allCoursesStatusOptions.filter(
        (o) => o.value === "" || validStatuses.has(o.value)
      );
    },
    coursesFilteredExceptType() {
      return this.allCourses.filter((c) => {
        if (this.selectedSubjectType?.value && c.subjectId !== this.selectedSubjectType.value) return false;
        if (this.selectedCourseTag?.tagId) {
          const tagIds = (c.courseTags || []).map((t) => t.tagId);
          if (!tagIds.includes(this.selectedCourseTag.tagId)) return false;
        }
        if (this.selectedCourseStatus?.value && c.courseStatus !== this.selectedCourseStatus.value) return false;
        if (this.courseCode && !(c.courseCode || "").includes(this.courseCode)) return false;
        if (this.courseSelected?.value && c.courseId !== this.courseSelected.value) return false;
        return true;
      });
    },
    courseType() {
      const validTypes = new Set();
      this.coursesFilteredExceptType.forEach((c) => {
        if (c.courseOnlineType === "FLEX") {
          validTypes.add("ONLINE");
          validTypes.add("ONSITE");
        } else if (c.courseOnlineType) {
          validTypes.add(c.courseOnlineType);
        }
      });
      return this.allCourseType.filter(
        (o) => o.value === "" || validTypes.has(o.value)
      );
    },
    courseListOptions() {
      return [
        { label: "ทั้งหมด", value: "" },
        ...this.coursesFilteredExceptCourse.map((c) => ({
          label: c.courseName,
          value: c.courseId,
        })),
      ];
    },

    coursesFilteredExceptSubject() {
      return this.allCourses.filter((c) => {
        if (this.selectedCourseTag?.tagId) {
          const tagIds = (c.courseTags || []).map((t) => t.tagId);
          if (!tagIds.includes(this.selectedCourseTag.tagId)) return false;
        }
        if (this.courseSelected?.value && c.courseId !== this.courseSelected.value) return false;
        return true;
      });
    },

    subjectTypeOptions() {
      const validIds = new Set(this.coursesFilteredExceptSubject.map((c) => c.subjectId));
      const opts = this.allSubjects
        .filter((s) => validIds.has(s.st_id))
        .map((s) => ({ label: s.st_name, value: s.st_id }));
      return [{ label: "ทั้งหมด", value: "" }, ...opts];
    },

    coursesFilteredExceptTag() {
      return this.allCourses.filter((c) => {
        if (this.selectedSubjectType?.value && c.subjectId !== this.selectedSubjectType.value) return false;
        if (this.courseSelected?.value && c.courseId !== this.courseSelected.value) return false;
        return true;
      });
    },

    courseTagOptions() {
      const validTagIds = new Set();
      this.coursesFilteredExceptTag.forEach((c) =>
        (c.courseTags || []).forEach((t) => validTagIds.add(t.tagId)),
      );

      const filteredTags = this.allTags.filter(
        (t) => t.tagId !== null && validTagIds.has(t.tagId),
      );

      // always guarantee this exact default entry exists, first in the list
      return [
        { tagName: "ทั้งหมด", tagId: null, comId: null },
        ...filteredTags,
      ];
    },
  },
  methods: {
    ...mapActions("LearningHistory", ["getLearningHistoryList"]),
    getTags() {
      api
        .get(`/v1/tags`)
        .catch(({ response }) => {
          console.error(response);
        })
        .then(({ data }) => {
          this.allTags = data.data;
          let findMyTag = 0;
          let findCommonTag = 0;
          for (let i = 0; i < this.courseTagOptions.length; i++) {
            if (this.courseTagOptions[i].comId != null && findMyTag == 0) {
              findMyTag = 1;
              this.courseTagOptions.splice(i, 0, {
                tagId: null,
                tagName: "ทั้งหมด",
                comId: this.courseTagOptions[i].comId,
              });
              this.courseTagOptions.join();
            } else if (
              this.courseTagOptions[i].comId == null &&
              findCommonTag == 0
            ) {
              this.courseTagOptions.splice(i, 0, {
                tagId: null,
                tagName: "ทั้งหมด",
                comId: null,
              });
              this.courseTagOptions.join();
              findCommonTag = 1;
            }
          }
          this.selectedCourseTag = this.getDefaultTagOption();
        });
    },

    getCourses() {
      api
        .get(
          `/v1/companies/${this.comId}/courses?company_id=${this.comId}&type=ALL&sort_by=updated&sort_order=desc`,
        )
        .then(({ data }) => {
          this.allCourses = data.data;
          // this.getCourseListOptions();
        })
        .catch(({ response }) => {
          console.error(response);
        });
    },

    getCourseListOptions() {
      this.courseListOptions = this.courseList.map((course) => ({
        label: course.courseName,
        value: course.courseId,
      }));
    },

    async getSubjectData() {
      await api.get(`/v1/courses/academic-data`).then(({ data }) => {
        this.allSubjects = data.data.subjects;
        // this.getSubjectListOptions();
      });
    },

    async getCourseSalesData() {
      try {
        const params = this.courseSalesParamsValue;
        Object.keys(params).forEach((key) => {
          if (
            params[key] === null ||
            params[key] === undefined ||
            params[key] === ""
          ) {
            delete params[key];
          }
        });
        const { data } = await api.get(
          "/v1/analytics/revenues/get-course-sales-report",
          {
            params,
          },
        );
        this.courseSalesHistory = data;
      } catch (error) {
        console.error("getCourseSalesData error:", error);
      }
    },

    getSubjectListOptions() {
      this.subjectTypeOptions = [
        {
          label: "ทั้งหมด",
          value: "",
        },
        ...this.subjectList.map((subject) => ({
          label: subject.st_name,
          value: subject.st_id,
        })),
      ];
    },

    async searchCourseSalesHistory() {
      this.setCourseSalesParams();
      this.setDateParams();
      this.getCourseSalesData();
    },
    async showCalendarRange() {
      let rangeCalendar = document.getElementById("calendar-range-order");
      if (rangeCalendar.style.display == "inline-block") {
        this.isLoading = true;
        rangeCalendar.style.display = "none";
        this.range.start = null;
        this.range.end = null;
        this.showData = 1;
        await this.setDateParams();
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    async applyCalendarRange() {
      let rangeCalendar = document.getElementById("calendar-range-order");
      if (this.range.start != null && this.range.end != null) {
        this.isLoading = true;
        rangeCalendar.style.display = "none";
        this.showData = 1;
        await this.setDateParams();
      } else {
        rangeCalendar.style.display = "none";
      }
    },
    changeShowData() {
      this.perPage = this.selectedShow;
    },
    onRangeChange(value) {
      this.range = value;
      this.setDateParams();
    },
    setDateParams() {
      this.courseSalesParamsValue.startDate =
        this.range.start == null
          ? ""
          : moment(this.range.start).format("YYYY-MM-DD");
      this.courseSalesParamsLabel.startDate =
        this.range.start == null
          ? ""
          : moment(this.range.start).format("YYYY-MM-DD");

      this.courseSalesParamsValue.endDate =
        this.range.end == null
          ? ""
          : moment(this.range.end).format("YYYY-MM-DD");
      this.courseSalesParamsLabel.endDate =
        this.range.end == null
          ? ""
          : moment(this.range.end).format("YYYY-MM-DD");
    },
    setCourseSalesParams() {
      this.courseSalesParamsValue.cId = this.courseSelected ? this.courseSelected.value : "";
      this.courseSalesParamsLabel.cId = this.courseSelected ? this.courseSelected.label : "";
      // this.courseSalesParams.cName = this.courseSelected
      //   ? this.courseSelected.label
      //   : "";
      this.courseSalesParamsValue.cCode = this.courseCode ? this.courseCode : "";
      this.courseSalesParamsLabel.cCode = this.courseCode ? this.courseCode : "";
      this.courseSalesParamsValue.cTagId = this.selectedCourseTag.tagId
        ? this.selectedCourseTag.tagId
        : "";
      this.courseSalesParamsValue.cTagId = this.selectedCourseTag.tagId
        ? this.selectedCourseTag.tagId
        : "";
      this.courseSalesParamsLabel.cTagId = this.selectedCourseTag.tagName
        ? this.selectedCourseTag.tagName
        : "";
      this.courseSalesParamsValue.paidFlag = this.selectedCoursePaidFlag.value;
      this.courseSalesParamsLabel.paidFlag = this.selectedCoursePaidFlag.label;
      this.courseSalesParamsValue.purchaseBy = this.selectedPurchaseBy.value
        ? this.selectedPurchaseBy.value
        : "";
      this.courseSalesParamsValue.subjectId = this.selectedSubjectType.value
        ? this.selectedSubjectType.value
        : "";
      this.courseSalesParamsLabel.subjectId = this.selectedSubjectType.label
        ? this.selectedSubjectType.label
        : "";
      this.courseSalesParamsValue.cStatus = this.selectedCourseStatus.value
        ? this.selectedCourseStatus.value
        : "";
      this.courseSalesParamsLabel.cStatus = this.selectedCourseStatus.label
        ? this.selectedCourseStatus.label
        : "";
      this.courseSalesParamsValue.method = this.selectedPaymentMethod.value.length
        ? this.selectedPaymentMethod.value
        : "";
      this.courseSalesParamsLabel.method = this.selectedPaymentMethod.label
        ? this.selectedPaymentMethod.label
        : "";
      this.courseSalesParamsValue.cType = this.selectedCourseType.value
        ? this.selectedCourseType.value
        : "";
      this.courseSalesParamsLabel.cType = this.selectedCourseType.label
        ? this.selectedCourseType.label
        : "";

      this.courseSalesParamsValue.scId = this.selectedSubCompany || "";
    },
    getDefaultTagOption() {
      return this.courseTagOptions[0];
    },
    resetAdvancedSearch() {
      this.selectedCourseEnroll = null;
      this.selectedCourseTag = this.getDefaultTagOption();
      this.selectedPurchaseBy = { label: "ทั้งหมด", value: "" };
      this.selectedCourseStatus = { label: "สถานะทั้งหมด", value: "" };
      this.selectedSubjectType = { label: "ทั้งหมด", value: "" };
      this.selectedPaymentMethod = { label: "ทั้งหมด", value: [] };
      this.courseCode = null;
      this.courseSelected = { label: "ทั้งหมด", value: ""};
      this.selectedCourseType = { label: "ทั้งหมด", value: "" };
      this.selectedCoursePaidFlag = { label: "เฉพาะที่ขายได้แล้ว", value: 1 };
    },
    arraysEqual(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b)) return false;
      if (a.length !== b.length) return false;
      return a.every((v) => b.includes(v));
    },
  },
  watch: {
    selectedMember(newMember) {
      if (newMember !== null) {
        api.get(`v1/members/${newMember.value}/enrolls`).then(({ data }) => {
          this.coursesData = data.map((course) => ({
            label: course.courseName,
            value: course.cerId,
          }));
          this.hasCoursesData = false;
        });
      }
    },
    selectedCourseEnroll(newCourse) {
      if (newCourse !== null) {
        this.selectedCourseEnroll = newCourse;
      }
    },

    selectedPurchaseBy() {
      const stillValid = this.paymentMethodOptions.some((opt) =>
        this.arraysEqual(opt.value, this.selectedPaymentMethod.value),
      );
      if (!stillValid) {
        this.selectedPaymentMethod = this.allPaymentMethodOptions[0];
      }
    },

    selectedPaymentMethod() {
      const stillValid = this.purchaseByOptions.some(
        (opt) => opt.value === this.selectedPurchaseBy.value,
      );
      if (!stillValid) {
        this.selectedPurchaseBy = this.allPurchaseByOptions[0];
      }
    },
    courseListOptions(newOptions) {
      if (this.courseSelected?.value) {
        const stillValid = newOptions.some((o) => o.value === this.courseSelected.value);
        if (!stillValid) this.courseSelected = null;
      }
    },
    subjectTypeOptions(newOptions) {
      const current = this.selectedSubjectType?.value;
      if (!newOptions.some((o) => o.value === current)) {
        this.selectedSubjectType = newOptions[0];
      }
    },
    courseTagOptions(newOptions) {
      const current = this.selectedCourseTag?.tagId;
      const comId = this.selectedCourseTag?.comId;
      const stillValid = newOptions.some(
        (o) => o.tagId === current && o.comId === comId,
      );
      if (!stillValid) {
        this.selectedCourseTag = this.getDefaultTagOption();
      }
    },
    coursesStatusOptions(newOptions) {
      const current = this.selectedCourseStatus?.value;
      if (!newOptions.some((o) => o.value === current)) {
        this.selectedCourseStatus = newOptions[0];
      }
    },
    courseType(newOptions) {
      const current = this.selectedCourseType?.value;
      if (!newOptions.some((o) => o.value === current)) {
        this.selectedCourseType = newOptions[0];
      }
    },

    isAdvancedSearch(newVal) {
      if (!newVal) this.resetAdvancedSearch();
    },
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: "Prompt", sans-serif;
}

.widthPage {
  max-width: 81.25rem;
}

.input-course-code {
  height: 38px !important;
}
</style>
